<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back"
                                   :to="localePath('/wine-guide/portugal/douro-valley')"></nuxt-link>
                        Producers
                    </div>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/portugal/douro-valley/casa-ferreirinha')">Casa Ferreirinha
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/portugal/douro-valley/howards-folly')">Howard’s Folly
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country two-line"
                               :to="localePath('/wine-guide/portugal/douro-valley/prats-and-symington')">Prats and
                        Symington (Chryseia)
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/portugal/douro-valley/quinta-do-crasto')">Quinta do Crasto
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/portugal/douro-valley/quinta-do-vale-meao')">Quinta Do Vale
                        Meao
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country active"
                               :to="localePath('/wine-guide/portugal/douro-valley/quinta-do-vallado')">Quinta Do Vallado
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/portugal/douro-valley/quinta-do-vesuvio')">Quinta Do Vesuvio
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country two-line"
                               :to="localePath('/wine-guide/portugal/douro-valley/roquette-cazes-quinta')">Roquette
                        &amp; Cazes — Quinta do Crasto
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/portugal/douro-valley/symington')">Symington
                    </nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back"
                                   :to="localePath('/wine-guide/portugal/douro-valley')"></nuxt-link>
                        Producers
                    </div>
                    <v-select
                        :items="items"
                        v-model="select"
                        label="Please choose"
                        single-line
                        item-text="report"
                        item-value="src"
                        return-object
                        class="show-mobile show-mobile-select"
                        v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Quinta Do Vallado</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Piuttosto come lo Champagne, il vino Porto (o semplicemente Porto o Porto, come preferisci) può essere chiamato come tale solo se proviene dal sacro tratto di terra sull'alto fiume Douro chiamato (immaginativamente) Il Douro. Qualsiasi altro vino Porto (maiuscolo) è falso o illegale. E il governo portoghese lo controlla come falchi.
                        <br><br>
                        Con un controllo così rigoroso sui 19.000 ettari di terreno, non sorprende che ci siano solo una manciata di vini di Porto che possono rivendicare legalmente il titolo. E anche se la tenuta può rivendicare l'autenticità, allora hai il campo minato della divisione nelle quattro tipologie principali: rubino, bianco, rosa e bruno. Basti dire che, quando si tratta di investire nei vini di Porto, niente è semplice.
                    </div>

                    <div class="howto-title2">Un porto che vale la pena cercare</div>
                    <div class="howto-text">
                        Quindi è un gradito sollievo che non ci sia nulla di complicato in Quita Do Vallado. Con una delle storie più lunghe nella valle del Douro, si può indicare la pagina nei documenti ufficiali del 1716 in cui sono menzionati. Come con Quinta Do Vesuvio (e circa 30 altre tenute vinicole di Porto), Vallado era un tempo sotto la gestione della leggendaria Antonia Ferreira, che ha molto a che fare con la sua formidabile reputazione. Oggi la tenuta è gestita dalla sesta generazione della famiglia Ferreira con i cugini Francisco Ferreira e João Ferreira Álvares Ribeiro al timone.
                    </div>

                    <div class="howto-title2">Tenerlo in famiglia</div>
                    <div class="howto-text">
                        I cugini gestiscono insieme la tenuta dal xxx e hanno portato oltre 300 anni di tradizione nel 21° secolo. Mentre i porti di Vallado erano sempre stati ben accolti, Ferreira e Ribeiro sono passati dalla secolare tradizione di vendere la produzione della fattoria alla Ferreira Portwine House per la produzione, l'imbottigliamento e la commercializzazione dei propri vini. Questa decisione ha visto un aumento di prezzo sia per i Tawny Port di 20 che per quelli di 40 anni, con prezzi medi che oggi raggiungono i 50 € per mezzo litro in Europa per i primi e fino a 180 € all'estero. Nel 2015, il famoso critico enologico Robert Parker ha assegnato al 20enne Quinta do Vallado Tawny Port un punteggio di 93 punti, mentre il suo fratello di 40 anni ha rubato la scena con un punteggio di 95 punti su 100. Questo, ovviamente, ha influenzato positivamente il valore del mercato secondario del vino.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Quinta Do Vallado</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Ähnlich wie Champagner kann Portwein (oder einfach Portwein oder Porto, je nachdem, was Sie bevorzugen) nur dann als solcher bezeichnet werden, wenn er aus dem heiligen Landstrich am oberen Douro-Fluss stammt, der (phantasievoll) Douro genannt wird. Jeder andere (in Großbuchstaben geschriebene) Portwein ist entweder gefälscht oder illegal. Und die portugiesische Regierung kontrolliert das wie ein Falke.
                        <br><br>
                        Angesichts der strengen Kontrolle über die 19.000 Hektar Land ist es nicht verwunderlich, dass es nur eine Handvoll Portweine gibt, die den Titel rechtlich beanspruchen können. Und selbst wenn das Anwesen Authentizität beanspruchen kann, steht man vor dem Minenfeld der Einteilung in die vier Haupttypen: Rubin, Weiß, Rosa und Gelbbraun. Es genügt zu sagen, dass es bei der Investition in Portweine nichts Einfaches gibt.
                    </div>

                    <div class="howto-title2">Ein Hafen, nach dem es sich zu suchen lohnt</div>
                    <div class="howto-text">
                        Daher ist es eine willkommene Erleichterung, dass Quita Do Vallado nichts Kompliziertes ist. Mit einer der längsten Geschichten im Douro-Tal kann man auf die Seite in den offiziellen Aufzeichnungen von 1716 verweisen, auf der sie erwähnt werden. Wie Quinta Do Vesuvio (und rund 30 andere Portweingüter) stand Vallado einst unter der Leitung der legendären Antonia Ferreira, was viel mit seinem zweifelhaften Ruf zu tun hat. Heute wird das Anwesen von der sechsten Generation der Familie Ferreira geführt, an deren Spitze die Cousins Francisco Ferreira und João Ferreira Álvares Ribeiro stehen.
                    </div>

                    <div class="howto-title2">Es bleibt in der Familie</div>
                    <div class="howto-text">
                        Die Cousins bewirtschaften das Anwesen seit dem 20. Jahrhundert gemeinsam und haben eine über 300-jährige Tradition ins 21. Jahrhundert gebracht. Während die Häfen von Vallado schon immer gut angenommen wurden, wechselten Ferreira und Ribeiro von der jahrhundertealten Tradition, die Produktion der Farm an das Portweinhaus Ferreira zu verkaufen, zur Produktion, Abfüllung und Vermarktung ihrer Eigenmarkenweine. Diese Entscheidung führte zu einer Preiserhöhung sowohl für die 20 als auch für die 40 Jahre alten Tawny Portweine, wobei die Durchschnittspreise heute in Europa bei etwa 50 € für einen halben Liter liegen und im Ausland bei bis zu 180 € liegen. Im Jahr 2015 bewertete der renommierte Weinkritiker Robert Parker den 20 Jahre alten Quinta do Vallado Tawny Port mit 93 Punkten, während sein 40 Jahre alter Bruder mit 95 von 100 Punkten die Show stahl. Dies hat sich natürlich positiv auf den Sekundärmarktwert des Weins ausgewirkt.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Quinta Do Vallado</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Un peu comme le Champagne, le vin de Porto (ou simplement le Porto ou le Porto, selon votre préférence) ne peut être nommé comme tel que s'il provient de la terre sacrée du haut Douro appelée (immaginativement) le Douro. Tout autre vin de Porto (en majuscule) est soit faux, soit illégal. Et le gouvernement portugais contrôle cela comme des faucons.
                        <br><br>
                        Avec un contrôle aussi strict sur les 19 000 hectares de terres, il n'est pas surprenant qu'il n'y ait qu'une poignée de vins de Porto qui puissent légalement revendiquer le titre. Et même si le domaine peut revendiquer l'authenticité, vous avez alors le champ de mines de la division en quatre grands types : rubis, blanc, rose et fauve. Autant dire que lorsqu'il s'agit d'investir dans les vins de Porto, rien n'est simple.
                    </div>

                    <div class="howto-title2">Un port qui vaut la peine d'être recherché</div>
                    <div class="howto-text">
                        C'est donc un soulagement bienvenu qu'il n'y ait rien de compliqué à Quita Do Vallado. Avec l'une des plus longues histoires de la vallée du Douro, on peut indiquer la page des archives officielles de 1716 où elles sont mentionnées. Comme pour Quinta Do Vesuvio (et une trentaine d'autres domaines viticoles de Porto), Vallado était autrefois sous la direction de la légendaire Antonia Ferreira, ce qui a beaucoup à voir avec sa redoutable réputation. Aujourd'hui, le domaine est dirigé par la sixième génération de la famille Ferreira avec les cousins Francisco Ferreira et João Ferreira Álvares Ribeiro à la barre.
                    </div>

                    <div class="howto-title2">Le garder dans la famille</div>
                    <div class="howto-text">
                        Les cousins ont géré le domaine ensemble depuis xxx et ont fait entrer plus de 300 ans de tradition dans le 21ème siècle. Alors que les ports de Vallado ont toujours été bien accueillis, Ferreira et Ribeiro sont passés de la tradition séculaire de vente de la production de la ferme à la maison Ferreira Portwine à la production, la mise en bouteille et la commercialisation de leurs propres vins. Cette décision a entraîné une augmentation du prix de leurs Portos Tawny de 20 et 40 ans, les prix moyens atteignant aujourd'hui environ 50 € le demi-litre en Europe pour le premier et jusqu'à 180 € à l'étranger. En 2015, le célèbre critique de vin Robert Parker a attribué au Quinta do Vallado Tawny Port, âgé de 20 ans, un score de 93 points, tandis que son frère de 40 ans a volé la vedette avec un score de 95 points sur 100. Cela, bien sûr, a affecté positivement la valeur marchande secondaire du vin.
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Quinta Do Vallado</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Rather like Champagne, Port wine (or simply Port or Porto, whichever you prefer) can only be named as such if it comes from the hallowed stretch of land on the Upper Douro River called (immaginatively) The Douro. Any other (upper case) Port wine is either fake or illegal. And the Portuguese government controls this like hawks.
                        <br><br>
                        With such stringent control over the 19,000 hectares of land, it is not surprising that there are only a handful of Port wines that can legally claim the title. And even if the estate can claim authenticity, you then have the minefield of dividing into the four main types: ruby, white, rose and tawny. Suffice to say, when it comes to investing in Port wines, nothing is simple.
                    </div>

                    <div class="howto-title2">A Port worth looking for</div>
                    <div class="howto-text">
                        So it comes as a welcome relief that there is nothing complicated about Quita Do Vallado. With one of the longest histories in the Douro valley, one can point to the page in the 1716 official records where they are mentioned. As with Quinta Do Vesuvio (and around 30 other Port wine estates), Vallado was once under the legendary Antonia Ferreira’s management, which has much to do with its redoubtable reputation. Today the estate is run by the sixth generation of the Ferreira family with cousins Francisco Ferreira and João Ferreira Álvares Ribeiro at the helm.
                    </div>

                    <div class="howto-title2">Keeping it in the family</div>
                    <div class="howto-text">
                        The cousins have managed the estate together since xxx, and have brought 300 plus years of tradition into the 21st-century. While Vallado ports had always been well-received, Ferreira and Ribeiro moved from the centuries-old tradition of selling the farm´s production to the Ferreira Portwine House to the production, bottling and marketing of their own-label wines. This decision saw an increase in price for both their 20 and 40 Year Old Tawny Ports, with average prices today reaching around €50 for a half-litre in Europe for the former and up to €180 overseas. In 2015, renowned wine critic Robert Parker gave the 20 year old Quinta do Vallado Tawny Port a score of 93 points, while its 40 year old sibling stole the show with a score of 95 points out of 100. This, of course, has affected the wine’s secondary market value positively.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "QuintaDoVallado",
    data() {
        return {
            select: {report: 'Quinta Do Vallado', src: '/wine-guide/portugal/douro-valley/quinta-do-vallado'},
            items: [
                {report: 'Casa Ferreirinha', src: '/wine-guide/portugal/douro-valley/casa-ferreirinha'},
                {report: 'Howard’s Folly', src: '/wine-guide/portugal/douro-valley/howards-folly'},
                {
                    report: 'Prats and Symington (Chryseia)',
                    src: '/wine-guide/portugal/douro-valley/prats-and-symington'
                },
                {report: 'Quinta do Crasto', src: '/wine-guide/portugal/douro-valley/quinta-do-crasto'},
                {report: 'Quinta Do Vale Meao', src: '/wine-guide/portugal/douro-valley/quinta-do-vale-meao'},
                {report: 'Quinta Do Vallado', src: '/wine-guide/portugal/douro-valley/quinta-do-vallado'},
                {report: 'Quinta Do Vesuvio', src: '/wine-guide/portugal/douro-valley/quinta-do-vesuvio'},
                {
                    report: 'Roquette & Cazes — Quinta do Crasto',
                    src: '/wine-guide/portugal/douro-valley/roquette-cazes-quinta'
                },
                {report: 'Symington', src: '/wine-guide/portugal/douro-valley/symington'}
            ]
        }
    },
    methods: {
        changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
    },
    head: {
        title: 'Quinta Do Vallado | Vindome Wine Guide',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Discover the rich flavors and character of the Douro Valley with Quinta Do Vallado wine producer. Experience the exceptional quality of premium Portuguese wines, crafted from hand-picked grapes grown in the region\'s rolling hills and terraced vineyards. Indulge in the unique and captivating aromas and tastes of these world-class wines.'
            }
        ],
        bodyAttrs: {
            class: 'wine-guide inner-page'
        }
    }
}
</script>

<style scoped>
.container {
    max-width: 1170px;
    padding: 0;
    font-family: 'Poppins', sans-serif;
}

.wine-guide-body {
    padding-top: 35px;
}

.wine-guide-left {
    width: 300px;
    display: inline-block;
}

.wine-guide-right {
    display: inline-block;
    width: calc(100% - 305px);
    vertical-align: top;
}

.wine-guide-left-title {
    font-weight: 600;
    color: #024E7B;
    font-size: 18px;
    height: 57px;
    line-height: 57px;
}

.wine-guide-country {
    display: block;
    height: 57px;
    line-height: 57px;
    text-decoration: none;
    color: #000;
    font-size: 16px;
    padding-left: 30px;
    width: 260px;
    border-left: 3px solid transparent;
}

.wine-guide-country:hover,
.wine-guide-country.active {
    border-color: #024E7B;
    background: #E5EDF2;
}
</style>
